import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCgLfySw6NscvjxfzHMcpAQJIRNuNahtPE",
  authDomain: "qiklook-ll.firebaseapp.com",
  databaseURL: "https://qiklook-ll-default-rtdb.firebaseio.com",
  projectId: "qiklook-ll",
  storageBucket: "qiklook-ll.firebasestorage.app",
  messagingSenderId: "874494915400",
  appId: "1:874494915400:web:ca578e6f80760e9a1a797d",
  measurementId: "G-P3PXZY3FHY"
};

// Inicializa o Firebase
const app = initializeApp(firebaseConfig);

// Exporta instâncias do Firestore e Storage
export const db = getFirestore(app);
export const storage = getStorage(app);
